<template>
  <v-container fluid>
    <v-sheet
        v-if="!loaded"
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="px-3 pt-3 pb-3">
      <v-row dense>
        <v-col cols="3">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"/>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"/>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"/>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"/>
        </v-col>
      </v-row>
    </v-sheet>
    <v-row dense>
      <v-col cols="11" style="margin:0 2em 0 2em">
        <v-card :loading="!loaded">
          <v-card-title>
            {{ project.name }}
          </v-card-title>
          <v-card-actions>
            <v-btn
                color="blue lighten-3"
                class="ma-2 white--text"
                outlined
                v-if="project.paid_progress==='0'"
                @click="generateInvoice">
              Generar Factura
              <v-icon right dark>mdi-file-document</v-icon>
            </v-btn>
            <v-btn
                color="blue lighten-3"
                class="ma-2 white--text"
                v-if="project.paid_progress<'3'"
                outlined
            @click="generatePartialInvoice">
              {{getPartialButtonText()}}
              <v-icon right dark>mdi-file-document</v-icon>
            </v-btn>
          </v-card-actions>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12"
                       md="6">
                  <v-text-field
                      color="rgba(0, 0, 0, 0.65)"
                      label="Cliente"
                      v-model="project.socialName"
                      :readonly=true
                   />
                </v-col>
                <v-col cols="12"
                       md="6">
                  <v-text-field
                      color="rgba(0, 0, 0, 0.65)"
                      :readonly=true
                      label="fecha"
                      v-model="project.date_add"
                   />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                      color="rgba(0, 0, 0, 0.65)"
                      label="subtotal"
                      v-model="project.subtotal_end"
                      :readonly=true
                   />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                      color="rgba(0, 0, 0, 0.65)"
                      label="irpf"
                      v-model="project.irpf_end"
                      :readonly=true />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                      color="rgba(0, 0, 0, 0.65)"
                      label="iva"
                      v-model="project.iva_end"
                      :readonly=true />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                      color="rgba(0, 0, 0, 0.65)"
                      label="iva"
                      v-model="project.total_end"
                      :readonly=true />
                </v-col>
                <v-col cols="12" md="4">
                  <h4>Progreso de pago</h4>
                  <v-progress-linear
                      v-model="getProgress"
                      height="25">
                    <strong v-if="project.paid_progress==='0'">0%</strong>
                    <strong v-if="project.paid_progress==='1'">33%</strong>
                    <strong v-if="project.paid_progress==='2'">66%</strong>
                    <strong v-if="project.paid_progress==='3'">100%</strong>
                  </v-progress-linear>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                      color="rgba(0, 0, 0, 0.65)"
                      label="Cantidad pagada"
                      v-model="project.totalpaid"
                      :readonly=true />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                      color="rgba(0, 0, 0, 0.65)"
                      label="Cantidad restante"
                      v-model="project.restantamount"
                      :readonly=true />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <h3 class="ml-5">Items</h3>
          <v-simple-table style="background-color: #fff !important;">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">titulo</th>
                <th class="text-left">descripcion</th>
                <th class="text-left">precio</th>
                <th class="text-left">Cantidad</th>
                <th class="text-left">descuento</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in projectItems" :key="item.itemID">
                <td>{{item.name}}</td>
                <td>{{item.description}}</td>
                <td>{{item.price}}€</td>
                <td>{{item.quantity}}</td>
                <td>{{item.discount}}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-card>
      </v-col>
    </v-row>
    <newitem :refresh="getData"/>
  </v-container>
</template>

<script>

import Newitem from "../components/home/newitem";
export default {
  name: "Budget",
  inject: ['theme'],
  components: {Newitem},
  data() {
    return {
      loaded:false,
      project:null,
      projectItems:[]
    }
  },
  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      let url = this.base_url + '/invV2/admin/proyecto/' + this.$route.params.id + '/' + localStorage.token;
      this.axios.get(url).then(response => {
        this.project = response.data.project;
        this.projectItems = response.data.projectItem;
        this.loaded = true;
      });
    },
    getProgress(){
      switch (this.project.paid_progress){
        case 0:
          return 0;
        case 1:
          return 33;
        case 2:
          return 66;
        case 3:
          return 100;
      }
    },
    generateInvoice(){
      let formData = new FormData();
      formData.set('pid', this.$route.params.id);
      formData.set('token', localStorage.token);
      let url = this.base_url + "/invV2/admin/generarfactura";
      this.axios.post(url, formData).then(() => {
        this.refresh();
      });
    },
    generatePartialInvoice(){
      let formData = new FormData();
      formData.set('pid', this.$route.params.id);
      formData.set('token', localStorage.token);
      let url ='';
      if(this.project.paid_progress === '0')
      url = this.base_url + "/invV2/admin/generarprimerpago";
      if(this.project.paid_progress === '1')
         url = this.base_url + "/invV2/admin/generarsegundopago";
      if(this.project.paid_progress === '2')
         url = this.base_url + "/invV2/admin/generarpagofinal";
      this.axios.post(url, formData).then(() => {
        this.refresh();
      });
    },
    getPartialButtonText(){
      switch (this.project.paid_progress){
        case '0':
          return 'Generar primer pago';
        case '1':
          return 'Generar segundo pago';
        case '2':
          return 'Generar pago final';
      }
    }
  }
}
</script>

<style scoped>
.clientLink {
  text-decoration: none;
  color: black;
  font-weight: bold;
}
</style>